import { TaskcommentsApi } from '../api-clients';
import { wrap } from '../wrap';

export const taskcommentApi = {
  index: wrap(TaskcommentsApi, TaskcommentsApi.prototype.indexTaskComment),
  create: wrap(TaskcommentsApi, TaskcommentsApi.prototype.createTaskComment),
  update: wrap(TaskcommentsApi, TaskcommentsApi.prototype.updateTaskComment),
  show: wrap(TaskcommentsApi, TaskcommentsApi.prototype.showTaskComment),
  delete: wrap(TaskcommentsApi, TaskcommentsApi.prototype.deleteTaskComment),
};
